module.exports = __webpack_public_path__ + "static/media/list.7ba478db.svg";